export default "__VITE_ASSET__CWyignbh__"